import axios from "axios";

interface User {
  name: string;
  email: string;
  key: number;
}

interface UserGetResult {
  result: User[];
}

export const getTeam = async () => {
  const { data } = await axios.get<UserGetResult>(`/management/get_team`);

  for (let i = 0; i < data.result.length; i++) {
    data.result[i].key = i;
  }

  return data.result;
};
